import {
  getList,
  LeoUUID,
} from "@surya-digital/leo-ts-types";
import { TableFilter, TableFilterDTO, TableFilterEnums } from "../types/tableFilter";


export namespace SpocSelection {
  export interface AllRowsSelectedDTO {
    case: string;
    filters: TableFilterDTO[];
  }
  
  export class AllRowsSelected {
    readonly isSpocSelectionAllRowsSelected: boolean = true;
  
    readonly filters: TableFilter[];
  
    static readonly constraints = {
      "filters": {
        "maxSize": 5,
      }
    }
  
    constructor(
    filters: TableFilter[]
    ) {
      AllRowsSelected.validateFilters(filters);
      this.filters = filters;
    }
  
    static fromDTO(dto: AllRowsSelectedDTO): AllRowsSelected {
      const filters = getList<TableFilterDTO, TableFilter>(
        dto,
        "filters",
        TableFilter.fromDTO,
        InvalidSpocSelectionAllRowsSelectedFiltersError
      );
      return new AllRowsSelected(
        filters
      );
    }
  
    toDTO(): AllRowsSelectedDTO {
      const dto: AllRowsSelectedDTO = {
        case: "ALL_ROWS_SELECTED",
          filters: this.filters.map((e: TableFilter) => { return e.toDTO() })
      };
      return dto;
    }
    private static validateFilters = (filters: TableFilter[]): void => {
      if(filters.length > 5) {
        throw new InvalidSpocSelectionAllRowsSelectedFiltersMaxSizeError(
          5,
          `Attribute filters is too long. Size is ${filters.length}. Max size is 5.`
        );
      }
    }
    
  }
  
  AllRowsSelected.prototype.toString = function toString(): string {
    return `SpocSelection.ALL_ROWS_SELECTED(filters='${this.filters}')`;
  };
  
  export interface SomeRowsSelectedDTO {
    case: string;
    selectedSpocIds: string[];
  }
  
  export class SomeRowsSelected {
    readonly isSpocSelectionSomeRowsSelected: boolean = true;
  
    readonly selectedSpocIds: LeoUUID[];
  
    static readonly constraints = {
      "selectedSpocIds": {
        "minSize": 1,
      }
    }
  
    constructor(
    selectedSpocIds: LeoUUID[]
    ) {
      SomeRowsSelected.validateSelectedSpocIds(selectedSpocIds);
      this.selectedSpocIds = selectedSpocIds;
    }
  
    static fromDTO(dto: SomeRowsSelectedDTO): SomeRowsSelected {
      const selectedSpocIds = getList<string, LeoUUID>(
        dto,
        "selectedSpocIds",
        (e: string) => new LeoUUID(e),
        InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsError
      );
      return new SomeRowsSelected(
        selectedSpocIds
      );
    }
  
    toDTO(): SomeRowsSelectedDTO {
      const dto: SomeRowsSelectedDTO = {
        case: "SOME_ROWS_SELECTED",
          selectedSpocIds: this.selectedSpocIds.map((e: LeoUUID) => { return e.toDTO(); })
      };
      return dto;
    }
    private static validateSelectedSpocIds = (selectedSpocIds: LeoUUID[]): void => {
      if(selectedSpocIds.length < 1) {
        throw new InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsMinSizeError(
          1,
          `Attribute selectedSpocIds is too short. Size is ${selectedSpocIds.length}. Min size is 1.`
        );
      }
    }
    
  }
  
  SomeRowsSelected.prototype.toString = function toString(): string {
    return `SpocSelection.SOME_ROWS_SELECTED(selectedSpocIds='${this.selectedSpocIds}')`;
  };
  

  export type SpocSelection = AllRowsSelected | SomeRowsSelected;

  export type SpocSelectionDTO = AllRowsSelectedDTO | SomeRowsSelectedDTO;

  export const fromDTO = (dto: SpocSelectionDTO): SpocSelection => {
    switch (dto.case) {
      case "ALL_ROWS_SELECTED":
          return AllRowsSelected.fromDTO(dto as AllRowsSelectedDTO);
      case "SOME_ROWS_SELECTED":
          return SomeRowsSelected.fromDTO(dto as SomeRowsSelectedDTO);
      default:
        throw new InvalidSpocSelectionError(
            `Case ${dto.case} is not valid case of SpocSelection.`
        );
    }
  };
}

export class InvalidSpocSelectionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionError";
  }
}
export class InvalidSpocSelectionAllRowsSelectedError extends InvalidSpocSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionAllRowsSelectedError";
  }
}

export class InvalidSpocSelectionAllRowsSelectedFiltersError extends InvalidSpocSelectionAllRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionAllRowsSelectedFiltersError";
  }
}

export class InvalidSpocSelectionAllRowsSelectedFiltersMaxSizeError extends InvalidSpocSelectionAllRowsSelectedFiltersError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionAllRowsSelectedFiltersMaxSizeError";
  }
}

export class InvalidSpocSelectionSomeRowsSelectedError extends InvalidSpocSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionSomeRowsSelectedError";
  }
}

export class InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsError extends InvalidSpocSelectionSomeRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsError";
  }
}

export class InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsMinSizeError extends InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocSelectionSomeRowsSelectedSelectedSpocIdsMinSizeError";
  }
}
